import {
  Body,
  Col,
  Flex,
  Row,
  SubTitle,
  styled,
  useTheme,
} from '@teko/ds-desktop';
import { EditOutlined, TrashBinDeleteRemoveOutlined } from '@teko/ds-icon';
import { Checkbox } from '@teko/ui';
import { t } from 'i18n';

interface ILocationPickerItemProps {
  address: string;
  name: string;
  onClick: () => void;
  active: boolean;
  isDefault: boolean;
  telephone: string;
  addressNote: string;
  onEdit?: () => void;
  onRemove?: () => void;
}

export const LocationPickerItem = (props: ILocationPickerItemProps) => {
  const {
    address,
    onClick,
    active,
    name,
    isDefault,
    telephone,
    addressNote,
    onEdit,
    onRemove,
  } = props;

  const theme = useTheme();

  return (
    <Wrapper onClick={onClick} align="middle" justify="start" wrap={false}>
      <StyledCheckBox circle checked={active} />
      <Col marginLeft="s12" flex="1">
        <Row justify="start">
          <SubTitle
            style={{
              fontSize: '13px',
              color: theme.colors.black,
              fontWeight: 500,
            }}
          >
            {name}
          </SubTitle>
          {isDefault && (
            <Flex
              backgroundColor="#F0F5FF"
              paddingLeft="s8"
              paddingRight="s8"
              border="s4"
              justify="center"
              align="center"
              marginLeft="s4"
            >
              <Body
                style={{
                  fontSize: '12px',
                  color: theme.colors.primary,
                  fontWeight: 400,
                }}
              >
                {t('Mặc định')}
              </Body>
            </Flex>
          )}
        </Row>
        <SubTitle
          style={{
            fontSize: '13px',
            color: theme.colors.textSecondary,
          }}
        >
          {telephone}
        </SubTitle>
        <SubTitle
          style={{
            fontSize: '13px',
            color: theme.colors.textSecondary,
          }}
        >
          {address}
        </SubTitle>
        {!!addressNote && (
          <SubTitle
            style={{
              fontSize: '13px',
              color: theme.colors.textSecondary,
            }}
          >
            {t('Ghi chú')} : {addressNote}
          </SubTitle>
        )}
      </Col>
      {(!!onEdit || !!onRemove) && (
        <ActionsCol>
          {!!onEdit && (
            <EditOutlined
              size={18}
              color={theme.colors.textSecondary}
              onClick={(e) => {
                e.stopPropagation();
                onEdit();
              }}
            />
          )}
          {!!onRemove && (
            <TrashBinDeleteRemoveOutlined
              size={18}
              color={theme.colors.textSecondary}
              onClick={(e) => {
                e.stopPropagation();
                onRemove();
              }}
            />
          )}
        </ActionsCol>
      )}
    </Wrapper>
  );
};

const Wrapper = styled(Row)`
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  cursor: pointer;
`;

const ActionsCol = styled(Col)`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;

  svg {
    cursor: pointer;
  }
`;

const StyledCheckBox = styled(Checkbox)(
  ({ theme }) => `
  width: 16px;
  height: 16px;
  border: 1px solid ${theme.colors.primary};
`,
);
